export const STEP_MANAGER_ACTIONS = {
  COLLAPSE: 'COLLAPSE',
  EXPAND: 'EXPAND',
  UPDATE_STATUS: 'UPDATE_STATUS',
  UPDATE_DATA: 'UPDATE_DATA',
};
